import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TextField, Grid } from '@mui/material'

import BaseDialog from '../../BaseDialog'

import { useDataApi } from '../../../context/DataApiContext'
import { useNotificationsProvider } from '../../../context/NotificationsContext'
import AutoCompleteInput from '../../AutoCompleteInput'

export default function CreateEmailListDialog({ open, onClose, onCreated }) {
  const { t } = useTranslation()

  const { dataProvider } = useDataApi()
  const { showNotification } = useNotificationsProvider()

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [emails, setEmails] = useState([])

  const resource = 'emails/lists'

  const resetState = () => {
    // Clean form
    setLoading(false)
    setError('')
    setName('')
    setDescription('')
    setEmails([])
  }

  const onCloseDialog = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      onClose()
    } else {
      resetState()
      onClose()
    }
  }

  const onConfirm = () => {
    if (name.length === 0) {
      setError('name_required')
      return
    }

    if (description.length === 0) {
      setError('description_required')
      return
    }

    if (emails.length === 0) {
      setError('emailIds_required')
      return
    }

    const body = {
      data: {
        name,
        description,
        emailIds: emails.map((email) => email.id),
      },
    }

    setLoading(true)
    dataProvider
      .post(resource, body)
      .then(() => {
        dataProvider.cache.reset()
        showNotification('success', t('create-email-list-dialog.success'))
        onCreated()
        resetState()
      })
      .catch(() => {
        showNotification('error', t('errors.api-error'))
        setLoading(false)
      })
  }
  return (
    <BaseDialog
      open={open}
      onClose={onCloseDialog}
      onConfirm={onConfirm}
      title={t('create-email-list-dialog.title')}
      loading={loading}
    >
      <Grid container direction="column" spacing={4}>
        <Grid item>
          <TextField
            variant="standard"
            required
            error={error === 'name_required'}
            helperText={t('common.required')}
            id="name"
            label={t('create-email-list-dialog.list-name')}
            fullWidth
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </Grid>
        <Grid item>
          <TextField
            variant="standard"
            required
            error={error === 'description_required'}
            helperText={t('common.required')}
            id="description"
            label={t('create-email-list-dialog.description')}
            fullWidth
            multiline
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </Grid>
        <Grid item>
          <AutoCompleteInput
            onChange={setEmails}
            value={emails}
            label={t('create-email-list-dialog.emails')}
            resource="/emails/autocomplete"
            error={error === 'emailIds_required'}
            helperText={t('common.required')}
            multiple
            required
            canDelete
            onKeyDown={(e) => {
              if (e.keyCode === 13 && e.target.value) {
                setEmails(
                  setEmails.concat({
                    id: (setEmails.length + 1) * -1,
                    title: (e.target.value || '').trim(),
                  })
                )
              }
            }}
          />
        </Grid>
      </Grid>
    </BaseDialog>
  )
}
